import React from "react";
import axios from 'axios';
import "./PageStyles.css";
import getMailgunApiKey from "../utilities/APIHelper";

const ApplyForSponsorship = () => {
  class SponsorshipForm extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        fullname: '',
        email: '',
        phoneNumber: '',
        socialMediaHandles: '',
        platforms: '',
        numberOfFollowers: '',
        categories: '',
        whyRated10: '',
        howDoYouEnvision: '',
        pastExperience: '',
      };
  
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }
  
    handleChange(event) {
      const { name, value } = event.target;
      this.setState({
        [name]: value
      });
    }
  
    async handleSubmit(event) {
      event.preventDefault();  
      const { email } = this.state;

      const mailgunApiKey = await getMailgunApiKey();
      const mailgunDomain = 'mail.rated10.app';
      const mailgunUrl = `https://api.mailgun.net/v3/${mailgunDomain}/messages`;
  
      const data = new URLSearchParams({
        from: email,
        to: 'mert@rated10.app',
        subject: "New Rated10 Sponsorship Application",
        text: Object.values(this.state).join('\n'),
      });
  
      try {
        await axios.post(mailgunUrl, data, {
          auth: {
            username: 'api',
            password: mailgunApiKey
          },
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
        this.setState({ message: 'Sponsorship application is submitted successfully!'});
      } catch (error) {
        console.error('Error sending email:', error);
        this.setState({ message: 'Failed to submit the application. Please try again later.' });
      }
    }
  
    render() {
      const { fullname, email, phoneNumber, socialMediaHandles, platforms, numberOfFollowers, categories, whyRated10, howDoYouEnvision, pastExperience, message } = this.state;
  
      const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '10vh',
        color: '#E35335',
        textAlign: 'center',
        padding: '10px 0',
        boxSizing: 'border-box'
      };

      const formStyle = {
        width: '100%',
        maxWidth: '500px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '10px',
        borderRadius: '8px',
        margin: '10px 0'
      };
  
      const inputStyle = {
        margin: '5px 0',
        padding: '10px',
        width: '100%',
        maxWidth: '500px'
      };
  
      const buttonStyle = {
        margin: '10px 0',
        padding: '10px 20px',
        backgroundColor: '#E35335',
        color: '#fff',
        border: 'none',
        cursor: 'pointer'
      };
  
      return (
        <div style={containerStyle}>
          <form onSubmit={this.handleSubmit} style={formStyle}>
            <input
              type="text"
              name="fullname"
              placeholder="Full Name"
              value={fullname}
              onChange={this.handleChange}
              required
              style={inputStyle}
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={email}
              onChange={this.handleChange}
              required
              style={inputStyle}
            />
            <input
              type="text"
              name="phoneNumber"
              placeholder="Phone Number (Optional)"
              value={phoneNumber}
              onChange={this.handleChange}
              required
              style={inputStyle}
            />
            <input
              type="text"
              name="socialMediaHandles"
              placeholder="Social Media Handles"
              value={socialMediaHandles}
              onChange={this.handleChange}
              required
              style={inputStyle}
            />
            <input
              type="text"
              name="platforms"
              placeholder="Platform(s) You Create Content On"
              value={platforms}
              onChange={this.handleChange}
              required
              style={inputStyle}
            />
            <input
              type="text"
              name="numberOfFollowers"
              placeholder="Number of Followers on Main Platform"
              value={numberOfFollowers}
              onChange={this.handleChange}
              required
              style={inputStyle}
            />
            <input
              type="text"
              name="categories"
              placeholder="Primary Content Categories (e.g., Fashion, Tech, Gaming, etc.)"
              value={categories}
              onChange={this.handleChange}
              required
              style={inputStyle}
            />
            <textarea
              name="whyRated10"
              placeholder="Why are you interested in a Rated10 Sponsorship?"
              value={whyRated10}
              onChange={this.handleChange}
              required
              rows="5"
              style={{ ...inputStyle, height: '150px' }}
            />
            <textarea
              name="howDoYouEnvision"
              placeholder="How do you envision collaborating with Rated10? "
              value={howDoYouEnvision}
              onChange={this.handleChange}
              required
              rows="5"
              style={{ ...inputStyle, height: '150px' }}
            />
            <textarea
              name="pastExperience"
              placeholder="Have you worked with sponsors before? If yes, please list them and describe your experience."
              value={pastExperience}
              onChange={this.handleChange}
              required
              rows="5"
              style={{ ...inputStyle, height: '150px' }}
            />
            <button type="submit" style={buttonStyle}>Submit</button>
          </form>
          {message && <p>{message}</p>}
        </div>
      );
    }
  }

  return (
    <div className="one-screen d-flex flex-column justify-content-between text-r10_orange text-center" style={{ padding: '10px', boxSizing: 'border-box', minHeight: '140vh' }}>
      <SponsorshipForm />
    </div>
  );
};

export default ApplyForSponsorship;
